import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Frame = {
  Component,
  makeDefault,
  isValidData,
} as const;

export type { FrameData, FrameNodeData } from './types';
